"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeTagsViewCell = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const classnames_1 = __importDefault(require("classnames"));
const attribute_tags_view_cell_styles_1 = require("./attribute-tags-view-cell.styles");
const attributes_1 = require("../../../../../../constants/attributes");
/**
 * View component for attribute tags (read-only view)
 * Wraps library TagsViewCell with Unknown value styling
 */
const AttributeTagsViewCell = ({ tags = [], disabled = false, isFailed = false, isSyncing = false, isSynced = false, }) => {
    // Callback to determine chip type - Unknown values get special red styling
    const getChipType = (0, react_1.useCallback)((chipValue) => (chipValue === attributes_1.SpecialAttributeValue.Unknown
        ? ui_components_1.ChipType.lightred
        : ui_components_1.ChipType.blue), []);
    const shouldShowSyncStatus = isSyncing || isFailed || isSynced;
    return (react_1.default.createElement(attribute_tags_view_cell_styles_1.StyledAttributeTagsViewCell, null, react_1.default.createElement(ui_components_1.TagsViewCell, { tags: tags, disabled: disabled, getChipType: getChipType }), shouldShowSyncStatus && (react_1.default.createElement(attribute_tags_view_cell_styles_1.StyledSyncStatusOverlay, { className: (0, classnames_1.default)({
            failed: isFailed && !isSyncing,
            synced: isSynced && !isSyncing && !isFailed,
            syncing: isSyncing,
        }) }))));
};
exports.AttributeTagsViewCell = AttributeTagsViewCell;
